<template>
  <v-container fluid class="home pt-0">
    <v-row>
      <v-col class="pt-0">
        <v-notification/>
      </v-col>
    </v-row>

    <template v-if="loadCompleted">
      <v-row>
        <v-col
          cols="12"
        >
          <v-row>

            <v-col
              cols="12"
              md="2"
              lg="2"
              v-for="(item, index) in $store.getters['user/isFree'] ? {manual, faq, kokugoRegisterdTitle, ruby, rubyDl} : {manual, faq, kokugoRegisterdTitle}"
              :key="index"
            >
              <v-manual-card
                style='width: 144px;'
                :detail="item.detail"
                @click="item.id === 8 ? $refs.rubyModal.open() : openUrl(item.to)"
              >
                <template v-slot:heading>
                  <v-img
                    :class="item.avatarClass"
                    :src="item.avatar"
                  />
                </template>
              </v-manual-card>
            </v-col>

          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <p class="ma-4 text mb-1">{{ title }}</p>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          v-for="(item, index) in items"
          :key="index"
        >
        <div :class="savedItemClasses(index)" v-if="(savedItems.preset.sheets.length !== 0 || savedItems.original.sheets.length !== 0 || savedItems.shingaku.sheets.length !== 0) && isActive">
          <template v-if="savedItems.preset.sheets.length && index === 0">
            ①かんたん！テスト作成で<br>途中保存のものがあります。
          </template>
          <template v-if="savedItems.original.sheets.length && index === 1">
            ②じっくり！オリジナルテスト作成で<br>途中保存のものがあります。
          </template>
          <template v-if="savedItems.shingaku.sheets.length && index === 2">
            ③進学教材から作成で<br>途中保存のものがあります。
          </template>
        </div>

          <v-clickable-card
            :detail="item.detail"
            :disabled="!isActive"
            primary
            @click="onClickCard(item)"
          >
            <template v-slot:heading>
              <v-img
                :class="item.avatarClass"
                :src="item.avatar"
              />
              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
                <v-list-item-subtitle class="subtitle">{{item.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:content>
              <v-img
                class="image"
                :src="item.src"
                height="233px"
              ></v-img>
            </template>
          </v-clickable-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
        >
          <v-clickable-card
            :detail="history.detail"
            @click="$router.push(history.to)"
          >
            <template v-slot:heading>
              <v-img
                :class="history.avatarClass"
                :src="history.avatar"
              />
              <v-list-item-content>
                <v-list-item-title>{{history.title}}</v-list-item-title>
                <v-list-item-subtitle class="subtitle">{{history.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-clickable-card>
        </v-col>

        <v-col
          class="text-center"
          cols="12"
          sm="12"
          md="6"
          lg="4"
        >
          <v-inquiry-button font-size="14px" />
        </v-col>
      </v-row>

    </template>

    <v-dialog
      v-if="item"
      v-model="restartDialog"
      persistent
      max-width="400px"
    >
      <v-card
        min-height="150px"
      >
        <v-overlay :value="isDeletingAll" absolute>
          <v-progress-circular indeterminate size="64" />
        </v-overlay>
        <v-toolbar
          class="title"
        >{{item.title}}</v-toolbar>

        <v-card-text class="px-5">
          <!-- 「再開」か「最初から」を選択するフェーズ -->
          <div class="py-3" v-if="!isSelectIncompleteSheet">
            <p class="mb-0">途中保存のデータがあります。</p>
            <p class="mb-0" style="font-size: 11px">※「最初から」を選択した場合は、途中保存のデータが新規作成されます。</p>
          </div>
          <!-- 「再開」を選択した時にどのデータを再開させるかを選ばせるフェーズ-->
          <div class="py-3" v-else>
            <p class="mb-0">再開したいデータを選択してください。</p>
            <p class="mb-2" style="font-size: 11px">※「削除」をクリックした場合、その途中保存データは削除されます。</p>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left pl-1 py-2 th_top">テスト名</th>
                    <th class="text-left pl-1 py-2 th_top">最終保存日時</th>
                    <th class="text-left pl-1 py-2 th_top">再開</th>
                    <th class="text-left pl-1 py-2 th_top">削除</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sheet in savedItems[item.code].sheets" :key="'sheet-'+sheet.id">
                    <td class="text-left pl-1 py-2 td_top">{{sheet.name}}</td>
                    <td class="text-left pl-1 py-2 td_top">{{sheet.created_at}}</td>
                    <td class="text-left pl-1 py-2 td_top">
                      <v-btn color="secondary" small dark @click="restart(sheet.id)">再開</v-btn>
                    </td>
                    <td class="text-left pl-1 py-2 td_top">
                      <v-btn icon @click.stop="openDeleteConfirmDialog(sheet)">
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>

        <v-card-actions class="card-action">
          <!-- 「再開」か「最初から」を選択するフェーズ -->
          <template  v-if="!isSelectIncompleteSheet">
            <v-btn color="secondary" dark class="dialog-Button" @click="isSelectIncompleteSheet = true">再開</v-btn>
            <v-btn color="#6DA5E6" dark class="dialog-Button" @click="start">最初から</v-btn>
            <v-btn color="gray" class="dialog-Button" @click="restartDialog = false">閉じる</v-btn>
          </template>
          <!-- 「再開」を選択した時にどのデータを再開させるかを選ばせるフェーズ-->
          <template v-else>
            <v-btn color="error" class="dialog-Button" @click="openDeleteAllConfirmDialog">全削除</v-btn>
            <v-spacer />
            <v-btn color="gray" class="dialog-Button" @click="isSelectIncompleteSheet = false">戻る</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-confirm-dialog
      ref="confirm"
      title="途中保存データ削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />

    <v-confirm-dialog
      ref="confirmDeleteAll"
      title="途中保存データ削除"
      message="作成途中のテストを全て削除します。よろしいですか。"
      buttonMessage="削除"
      @confirm="confirmDeleteAll"
    />

    <v-ruby-modal ref="rubyModal" />

  </v-container>
</template>

<script>

import VClickableCard from '@/components/molecules/ClickableCard'
import VManualCard from '@/components/molecules/ManualCard'
import VNotification from '@/components/molecules/Notification'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import VInquiryButton from '@/components/molecules/InquiryButton'
import VRubyModal from '@/components/molecules/RubyModal'
import config from "../../config"
import Qs from 'qs'

export default {
  components: {
    VClickableCard,
    VManualCard,
    VNotification,
    VConfirmDialog,
    VInquiryButton,
    VRubyModal,
  },

  data: () => ({
    items: [
      {
        id: 1,
        code: 'preset',
        src: require('@/assets/img/preset-exam.png'),
        avatarClass: "avatar-hight",
        avatar: require('@/assets/img/f_f_business_91_s512_f_business_91_0nbg.png'),
        title: '① かんたん！テスト作成',
        detail: '各教科書ごとに，標準的な出題範囲，<br>問題パターンで構成されたテストをベースに，簡単に定期テストが作成できます。問題重複もなく，そのまま安心してお使いいただけます。<br>※「保健・体育」については，「かんたん！テスト作成」の設定はございません。各学校の実情に合わせて，「②じっくり！オリジナルテスト作成」より作成願います。',
        to: '/teacher/preset_exam'
      },
      {
        id: 2,
        code: 'original',
        src: require('@/assets/img/original-exam.png'),
        avatarClass: "avatar-hight",
        avatar: require('@/assets/img/f_f_business_53_s512_f_business_53_0nbg.png'),
        title: '② じっくり！オリジナルテスト作成',
        detail: '出題範囲や問題数などの条件を細かく設定して，<br>オリジナルのテストが作成できます。<br>問題重複や内容バランスに注意しながら，ご作成ください。',
        to: '/teacher/original_exam'
      },
    ],
    history: {
      id: 3,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-wide",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '申し込み履歴',
      detail: '履歴を確認することができます。',
      to: '/teacher/history'
    },
    manual: {
      id: 4,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '作成マニュアル',
      to: '/manual.pdf'
    },
    faq: {
      id: 5,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: 'よくある質問',
      to: '/faq.pdf'
    },
    changeLog: {
      id: 6,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '令和6年度システム変更点',
      to: '/changeLog.pdf'
    },
    kokugoRegisterdTitle: {
      id: 7,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '国語教科書題材<br>問題登録一覧',
      to: '/kokugoRegisterdTitle.pdf'
    },
    ruby: {
      id: 8,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: 'ルビ振り<br>（オンライン処理）',
      to: null
    },
    rubyDl: {
      id: 10,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '「ルビ振りツール」<br>ダウンロード',
      to: '/2026_rubi.zip'
    },
    shingaku: {
      id: 9,
      code: 'shingaku',
      src: require('@/assets/img/shingaku-exam.png'),
      avatarClass: "avatar-hight",
      avatar: require('@/assets/img/f_f_business_91_s512_f_business_91_0nbg.png'),
      title: '③ 進学教材からテスト作成',
      detail: '進学教材の単元番号からテストが作成できます。',
      to: '/teacher/shingaku_exam'
    },
    savedItems: {
      preset:   {
        sheetId: null,
        restartSheets: null,
        sheets: []
      },
      original: {
        sheetId: null,
        restartSheets: null,
        sheets: []
      },
      shingaku: {
        sheetId: null,
        restartSheets: null,
        sheets: []
      },
    },
    item: null,
    loadCompleted: false,
    restartDialog: false,
    // 途中保存問題を選択する状態かどうかのフラグ
    isSelectIncompleteSheet: false,
    // 削除対象のsheetを格納
    deleteSheet: null,
    // 全削除中フラグ
    isDeletingAll: false,
  }),

  async created	() {
    // 配点リセット
    this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: 1 })
    this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: '100' })

    //作成途中の問題があるかチェック
    await this.getSavedSheetId('preset')
    await this.getSavedSheetId('original')
    await this.getSavedSheetId('shingaku')
    this.loadCompleted = true

    if (this.$store.state.user.isShingaku) {
      this.items.push(this.shingaku)
      this.items[0].detail = '各教科書ごとに，標準的な出題範囲，<br>問題パターンで構成されたテストをベースに，簡単に定期テストが作成できます。問題重複もなく，そのまま安心してお使いいただけます。進学教材の問題を選んだり，単元番号から検索したりすることができます。<br>※「保健・体育」については，「かんたん！テスト作成」の設定はございません。各学校の実情に合わせて，「②じっくり！オリジナルテスト作成」より作成願います。'
      this.items[1].detail = '出題範囲や問題数などの条件を細かく設定して，<br>オリジナルのテストが作成できます。進学教材の問題を選んだり，単元番号から検索したりすることができます。<br>問題重複や内容バランスに注意しながら，ご作成ください。'
    }
  },

  methods: {
    savedItemClasses(index) {
      return {
        'arrow-box': true,
        'mx-auto': true,
        'mb-3': true,
        'balloon':  (this.savedItems.preset.sheets.length != 0 && index === 0) || (this.savedItems.original.sheets.length != 0 && index === 1) || (this.savedItems.shingaku.sheets.length != 0 && index === 2)
      }
    },
    async getSavedSheetId(type) {
      //途中保存用にsubject_teachersを取得
      if(this.$store.state.top.subjectTeachers.length === 0) await this.$store.dispatch('getSubjectTeachers')
      //問題作成再開する必要があるか確認
      const subjectTeacherIds = this.$store.state.top.subjectTeachers.map(x => x=x.id)
      let params = {
        q: {
          subject_teacher_id_in: subjectTeacherIds,
          step_not_eq: config.step.COMPLETED,
          sheet_type_eq: type
        }
      }

      const restartSheets = await this.$axios.get('/api/v1/teacher/sheet/restart', {
        params: params,
        paramsSerializer: function(params) {
          return Qs.stringify(params, {arrayFormat: 'brackets'})
        }
      })

      this.savedItems[type].sheets = restartSheets.data.sheets
    },
    async onClickCard(item) {
      if (this.savedItems[item.code].sheets.length) {
        this.item = item
        this.restartDialog = true
      } else {
        // 問題検索条件リセット
        this.$store.commit('sheet/setSheetContentPages', { sheetContentPages: null })
        await this.$store.dispatch('initializeAllConditions')
        await this.$store.dispatch('getSubjectTeachers')
        this.$router.push(item.to)
      }
    },
    cancel() {
      this.dialog = false
      this.item = null
    },
    confirm() {
      this.dialog = false
      this.$emit('confirm')
    },
    async restart(sheetId) {
      // 参照ファイル欠損時はサーバ側で再生成が走り時間がかかるためローディングを表示
      this.$app.$refs.loading.open({ message: '読み込み中' })
      try {
        const restartSheet = await this.$axios.get(`/api/v1/teacher/sheet?id=${sheetId}`)
        const params = {"restartSheets": restartSheet}
        await this.$store.dispatch('sheet/getSheetContents', params)
        if (this.item.code === 'preset') {
          const res = await this.$axios(`/api/v1/teacher/presets?q[id_eq]=${restartSheet.data.search_conditions.preset_id}`)
          const preset = this.$store.getters['sheet/convertPresetData'](res.data[0])
          // 配点を設定
          this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: restartSheet.data.search_conditions.selected_max_point })

          await this.showDetail(preset, restartSheet)
        } else if (this.item.code === 'original'){
          await this.setConditions(restartSheet.data.search_conditions)
        }

        // 試験名セット
        this.$store.commit('sheet/setTitle', { title: restartSheet.data.name })

        // 最小縮小率に達した時の解答用紙の縮小方法セット
        this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: restartSheet.data.answer_reduction_type })

        // 大問ごとの配点欄を表示するかどうの選択肢をセット
        this.$store.commit('sheet/setIsUseAllotArea', { isUseAllotArea: restartSheet.data.is_use_allot_area })

        // 冊子タイプをセット (有料/デモユーザーは UI で選択不可なので 'print' 固定)
        const printType = this.$store.getters['user/isFree'] ? restartSheet.data.print_type : 'print'
        this.$store.commit('sheet/setPrintType', { printType })

        // 画面遷移
        switch(restartSheet.data.step){
          case 'replace_content':
            this.$router.push('/teacher/change')
            break
          case 'preview':
            this.$router.push('/teacher/result')
            break
          case 'score_setting':
            this.$router.push('/teacher/score_setting')
            break
          case 'sheet_naming':
            this.$router.push('/teacher/regist_exam')
        }
      } finally {
        this.$app.$refs.loading.close()
      }
    },
    async start() {
      this.$store.commit('sheet/setSheetContentPages', { sheetContentPages: null })
      await this.$store.dispatch('initializeAllConditions')
      // 問題検索条件リセット
      this.$store.dispatch('getSubjectTeachers')
      this.$router.push(this.item.to)
    },
    async setConditions(conditions){
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: conditions
      })

      // 選択学年
      const gradeId =
        conditions[0].grade_id || config.grades.CHU1 // 社会の場合学年が空になるのでデフォルト値を補完
      const selectedGrade = this.$store.state.master.allGrades.find(x => x.id == gradeId)
      this.$store.commit('setSelectedGrade', { grade: selectedGrade } )

      // 選択教科
      const selectedSubject = this.$store.getters['master/subjectRoot'](conditions[0].subject_id)
      this.$store.commit('setSelectedSubject', { subject: selectedSubject})

      // 条件リセット
      await this.$store.dispatch('initializeAllConditions')

      conditions.forEach(condition => {
        const subject = this.$store.state.master.allSubjects.find(x => x.id == condition.subject_id)
        // 選択条件の教科を設定
        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(x => x.code === subject.code)
          }
        )

        // 選択条件の詳細を設定
        const publisher = selectedSubject.publishers.find(x => x.id == condition.publisher_id)
        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: condition.page_ranges.map(range => { return {start:  String(range.start), end: String(range.end)} }),
          questionNum: String(condition.question_num),
          selectedWritingQuestion: condition.writing_question_flag,
          selectedDifficulty: this.$store.state.master.allDifficulties.find(x => x.id == condition.difficulty_id)
        })

        if (this.$store.getters.selectedSubjectHasChild) this.$store.commit('addSelectedShakaiOptions', { option: subject })

        // 配点を設定
        this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: conditions[0].selected_max_point_value })
        this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: conditions[0].selected_max_point })
      })
    },

    async showDetail(preset, restartSheets) {
      const subject = this.$store.state.master.allSubjects.find(x => x.name == preset.subjectName)
      this.$store.commit('setSelectedSubject', { subject: subject } )
      await this.$store.dispatch('initializeAllConditions')
      preset.details.forEach(detail => {
        // 社会の場合は分野をセット
        if (config.hasOptionSubjects.includes(preset.subjectCode)) {
          const option = this.$store.state.master.allSubjects.find(x => x.code === detail.subject_code)
          this.$store.commit('addSelectedShakaiOptions', { option: option })
        }

        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(condition => condition.code === detail.subject_code)
          }
        )

        const publisher = subject.publishers.find(x => x.name == detail.publisher_name)
        const grade = this.$store.state.master.allGrades.find(x => x.name == preset.grade)
        const ranges = preset.rangeData.find(x => x.subjectCode === detail.subject_code)?.ranges || []

        this.$store.commit('setSelectedGrade', { grade: grade } )
        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: ranges.map(range => ({ start: String(range[0]), end: String(range[1]) })),
          questionNum: String(detail.question_cnt)
        })
      })

      const params = {"preset_id": preset.id, "subject_id": restartSheets.data.search_conditions.subject_id, "restartSheets": restartSheets}
      await this.$store.dispatch('sheet/getSheetContents', params)
      //問題作成再開処理用にプリセットIDを保存
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: restartSheets.data.search_conditions
      })
    },
    // 全削除確認ダイアログを表示
    openDeleteAllConfirmDialog() {
      this.$refs.confirmDeleteAll.open()
    },
    // 途中保存データ全削除
    async confirmDeleteAll() {
      this.isDeletingAll = true
      try {
        const subjectTeacherIds = this.$store.state.top.subjectTeachers.map(x => x.id)
        const params = {
          q: {
            subject_teacher_id_in: subjectTeacherIds,
            step_not_eq: config.step.COMPLETED,
            sheet_type_eq: this.item.code
          }
        }
        await this.$axios.delete('/api/v1/teacher/sheets/destroy_all', {
          params: params,
          paramsSerializer: function(params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        this.$toasted.global.success({ message: '作成途中のテストを全て削除しました' })
        this.savedItems[this.item.code].sheets = []
        this.isSelectIncompleteSheet = false
        this.restartDialog = false
      } finally {
        this.isDeletingAll = false
      }
    },
    // 削除確認ダイアログを表示
    openDeleteConfirmDialog(sheet) {
      this.deleteSheet = sheet
      this.$refs.confirm.open()
    },
    // 途中保存データ削除
    async confirmDeletion() {
      await this.$axios.delete(`api/v1/teacher/sheets/${this.deleteSheet.id}`)
      this.$toasted.global.success({ message: `作成途中の「${this.deleteSheet.name}」を削除しました` })
      this.savedItems[this.item.code].sheets = this.savedItems[this.item.code].sheets
                                                .filter(sheet => sheet.id !== this.deleteSheet.id);
      if (this.savedItems[this.item.code].sheets.length === 0) {
        this.isSelectIncompleteSheet = false
        this.restartDialog = false
      }
      this.deleteSheet = null
    },

    openUrl(url) {
      window.open(url, '_blank')
    },
  },

  computed: {
    title() {
      return this.$store.state.user.isShingaku ? '①②③のいずれかを選んで作成してください。' : '①②のどちらかを選んで作成してください。'
    },
    deleteMessage() {
      return `作成途中の「${this.deleteSheet?.name}」を削除します。よろしいですか。`
    },
    isActive() {
      if (this.$store.getters['user/isPaid']) return true

      return this.$store.state.user.remainingDownloadCount > 0
    }
  }
}
</script>

<style lang="stylus" scoped>
.text
  color #313131
  box-shadow 0px 2px 0px 0px #2a5594
  display inline-block

.arrow-box{
    position:relative;
    max-width:344px;
    height:60px;
    text-align:center;
    color: #FF4F41;
    font-size:15px;
    font-weight:bold;
    border-radius:48px;
}

.avatar-hight
  max-width 40px
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.avatar-wide
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.avatar-manual
  margin-top: 10px;
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8

.image
  margin-top 10px
  box-shadow 0px 0px 3px 0px #b3b3b3

.title
  justify-content center
  background-color: #2a5594 !important
  color white

.card-action
  justify-content space-around

.dialog-Button
  width 100px
  height 50px

/* 吹き出し本体 */
.balloon{
  position: relative;
  padding: 10px;
  background-color: #d5eeff;
  box-shadow: 0px 0px 10px 0px #a7a7a7;         /* 吹き出し本体の影 */
}
/* 三角アイコン */
.balloon::before{
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  left: 27px;
  bottom: -12px;
  border-right: 15px solid transparent;
  border-top: 15px solid #d5eeff;
  border-left: 15px solid transparent;
}
</style>
